<template>
  <generic-container
    v-bind:show_plus="true"
    icon="user tie"
    :title="$t('job possitions')"
    v-on:add="add"
    :header_buttons="header_buttons"
  >
    <table
      class="ui blue celled very compact selectable striped table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("setup") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <job-possition-modal ref="job_possition_modal" @saved="init" />
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import {
  local_api,
  error_toast,
  init_ajax_data_datables,
  register_listener,
  enterprise_setup,
} from "@/utils";
import JobPossitionModal from "../job_possition_modal/Index";
import filters from "@/filters";

export default {
  name: "CardTypes",
  components: {
    GenericContainer,
    JobPossitionModal,
  },
  filters: filters,
  props: {},
  data() {
    return {
      // card_types: [],
      // type_modals: [],
      // selected_type: {},
      header_buttons: [
        {
          icon: "green refresh",
          click: this.populate,
        },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.job_possition_modal.show_modal();
    },
    remove(type) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove job possition?"),
        function () {
          local_api(vm, "post", "/user_job_possition/do-remove", {
            u: type.uuid,
          })
            .then(() => {
              console.log("removed");
              // vm.card_types.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    populate() {
      let vm = this;
      vm.init();
      // local_api(vm, "post", "/user_job_possition/do-get-list", {})
      //   .then((cardTypes) => {
      //     console.log("cardTypes: ", cardTypes);
      //   })
      //   .catch((err) => {
      //     error_toast(err);
      //   });
    },
    init() {
      let vm = this;
      /**
       * Datatable
       */
      let columns = [
        {
          data: function (row) {
            return row.name;
          },
        },
        {
          data: function (row) {
            // console.log(vm.enterprise_setup);
            let list = `<div class="ui list">`;
            if (row.setup && typeof row.setup == "string")
              row.setup = JSON.parse(row.setup);
            if (row.setup.default_salary)
              list += `<div lass="item">${vm.$t(
                "salary",
              )} ${filters.formatCurrency(
                row.setup.default_salary,
                vm.enterprise_setup.currency_iso,
              )}</div>`;
            return `${list}</div>`;
          },
        },
        // {
        //   data: function (row) {
        //     if (row && row.email)
        //       return `<i class="grey envelope icon"></i>${row.email}`;
        //     else return "";
        //   },
        // },
        {
          data: function (row) {
            let r = "";
            r += `<div class="ui mini icon basic button" onclick="window.dispatchEvent(new CustomEvent('edit_job_possition', { detail: { uuid: '${row.uuid}'}}))">
                      <i class="orange edit icon"></i>
                    </div>`;
            r += `<div class="ui mini icon basic button" onclick="window.dispatchEvent(new CustomEvent('delete_job_possition', { detail: { uuid: '${row.uuid}'}}))">
                      <i class="red trash icon"></i>
                    </div>`;
            return r;
          },
        },
      ];

      let onSelect = (/* data */) => {
        // console.log(data);
      };

      let onCreatedRow = (/* row, data */) => {};
      let requestTransform = () => {};
      let stateSaveParams = (/* settings, json */) => {
        setTimeout(() => {
          register_listener("delete_job_possition", function (e) {
            let uuid = e.detail.uuid;
            vm.$alertify.confirm(
              vm.$t("are you sure to remove job possition?"),
              function () {
                local_api(vm, "post", "/user_job_possition/do-remove", {
                  i: uuid,
                })
                  .then(() => {
                    vm.init();
                  })
                  .catch((err) => {
                    error_toast(err);
                  });
              },
            );
          });

          register_listener("edit_job_possition", function (e) {
            let uuid = e.detail.uuid;
            vm.$refs.job_possition_modal.show_modal({ uuid: uuid });
          });
        }, 1000);
      };

      let options = {
        stateSaveParams,
      };

      init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["user job list url"],
        columns,
        onSelect,
        onCreatedRow,
        requestTransform,
        options,
      );
    },
  },
};
</script>
